export default __webpack_public_path__ + "static/media/404img.b4647fda.jpg";